const TokenKey = 'Authorization'
export function getToken() {
	let auth = JSON.parse(localStorage.getItem(TokenKey))
	if (auth) {
		return auth.token
	}
	return null
}

export function setToken(token, expire) {
	return localStorage.setItem(TokenKey, JSON.stringify({ token: token, expiredAt: expire }))
}

export function removeToken() {
	return localStorage.removeItem(TokenKey)
}

/**
 * 判断token是否即将过期，提前30分钟
 * @returns {*}
 */
export function isTokenExpired() {
	let auth = JSON.parse(localStorage.getItem(TokenKey))
	if (auth && auth.expiredAt) {
		let expiredTime = auth.expiredAt / 1000 //从localStorage中取出token过期时间
		let nowTime = new Date().getTime() / 1000 //获取本地时间

		return expiredTime - nowTime < 30 * 60 //小于30分钟则说明即将过期
	} else {
		return false
	}
}

/**
 * 判断是否含有token
 * @returns {*}
 */
export function hasToken() {
	let auth = JSON.parse(localStorage.getItem(TokenKey))
	if (auth) {
		return true
	} else {
		return false
	}
}
